import { faTv } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { TeleorientacaoCardProps } from "../../../interfaces/props/SaudeOnline/TeleorientacaoCardProps";
import { formatDateTimeToISOFormat } from "../../../utils/DateFormat";
import { sxBoxFlexWrap, sxButtonTeleorientacaoCard, sxTypographyTeleorientacao, sxTypographyTeleorientacaoBold, sxTypographyTeleorientacaoRed } from "./sxProps";

const TeleorientacaoCard: React.FC<TeleorientacaoCardProps> = (props) => {

  const { agendamento, validSchedule, handleClickCancelarAtendimento } = { ...props };
  const navigate = useNavigate();

  const isJoinableTeleorientacaoSchedule = (): boolean => {
    let teleorientacao = agendamento.tipoAtend === 'TELEORIENTACAO VIDEO' && agendamento.codTipoAtend === 'TELEORIENVID';
    let joinableStatus = agendamento.status === 'confirmado' || agendamento.status === 'agendado';

    let joinable = teleorientacao && joinableStatus;
    return joinable;
  }

  const disableJoin = (): boolean => {
    let enable = agendamento.statusTelemedicina === 'disponivel' && agendamento.statusTelemedicinaAPI === 'Iniciada';
    return !enable;
  }

  const isCancellableTeleorientacaoSchedule = (): boolean => {
    let nowDateTime = new Date();
    let scheduleDateTime = new Date(formatDateTimeToISOFormat(agendamento.dataAgendamento, agendamento.horaAgendamento));
    let cancellableDate = nowDateTime <= scheduleDateTime;
    let cancellableStatus = agendamento.status === 'confirmado' || agendamento.status === 'agendado';

    let cancellable = cancellableDate && cancellableStatus;
    return cancellable;
  }

  const handleClickIngressarNoAtendimento = () => {
    navigate(`/saudeOnline/ingressarNoAtendimento/${agendamento.idReuniao}`);
  }

  return (
    <div className='teleorientacao-card'>
      <div id='card-icon-holder'>
        <FontAwesomeIcon icon={faTv} className='fadt-tv' />
      </div>
      <div className='teleorientacao-card-details'>
        <Box sx={sxBoxFlexWrap}>
          <Typography sx={sxTypographyTeleorientacaoBold}>Teleorientação em Saúde</Typography>
          {!validSchedule && <Typography sx={sxTypographyTeleorientacaoRed}>(expirado)</Typography>}
        </Box>
        <Box sx={sxBoxFlexWrap}>
          <Typography sx={sxTypographyTeleorientacaoBold}>Data/hora do atendimento:</Typography>
          <Typography sx={sxTypographyTeleorientacao}>{agendamento.dataAtendimento}</Typography>
        </Box>
        <div className='teleorientacao-action-buttons-holder'>
          {isJoinableTeleorientacaoSchedule() && <Button
            type='button'
            variant='contained'
            disabled={disableJoin()}
            sx={sxButtonTeleorientacaoCard}
            onClick={handleClickIngressarNoAtendimento}
          >
            <Typography>Ingressar no Atendimento</Typography>
          </Button>}
          {isCancellableTeleorientacaoSchedule() && <Button
            type='button'
            variant='outlined'
            sx={sxButtonTeleorientacaoCard}
            onClick={handleClickCancelarAtendimento}
          >
            <Typography>Cancelar Atendimento</Typography>
          </Button>}
        </div>
      </div>
    </div>
  )
}

export default TeleorientacaoCard;